export default __webpack_public_path__ + "static/media/276.687c77dc.jpg";